import { IconNames } from '@blueprintjs/icons';
import { FormInputContainer } from '@strata/react-form-input-container';
import { MessagingBlock } from '@strata/react-messaging-block';

export const ApplyTemplate = () => (
    <FormInputContainer className="padding__around--xx-large">
        <MessagingBlock
            size={MessagingBlock.Sizes.MEDIUM}
            icon={IconNames.ADD}
            iconStatus={MessagingBlock.Status.SUCCESS}
            primaryText="Apply a template!"
            secondaryText="To create a new rule apply a template from the list on the left."
        />
    </FormInputContainer>
);
